import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function exactLengthValidator(requiredLength: number, includeSpaces: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || typeof control.value !== 'string') {
      return null;
    }

    const value = includeSpaces ? control.value : control.value.replace(/\s/g, '');
    const actualLength = value.length;
    const errorResponse = {
      exactLength: {
        requiredLength,
        actualLength
      }
    };

    return actualLength === requiredLength ? null : errorResponse;
  };
}
